import { render, staticRenderFns } from "./ForumMessage.vue?vue&type=template&id=4049e8d4&scoped=true&"
import script from "./ForumMessage.vue?vue&type=script&lang=js&"
export * from "./ForumMessage.vue?vue&type=script&lang=js&"
import style0 from "./ForumMessage.vue?vue&type=style&index=0&id=4049e8d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4049e8d4",
  null
  
)

export default component.exports